export const SSN_LENGTH = 9;

export const ANNUAL_INCOME_VALUES = ['under_50k', '50k_100k', '100k_250k', '250k_plus'] as const;

export const NET_WORTH_VALUES = ['under_100k', '100k_500k', '500k_1M', '1M_plus'] as const;

export const TRADING_EXPERIENCE_VALUES = ['none', 'some', 'advanced'] as const;

export type AnnualIncome = (typeof ANNUAL_INCOME_VALUES)[number];
export type NetWorth = (typeof NET_WORTH_VALUES)[number];
export type TradingExperience = (typeof TRADING_EXPERIENCE_VALUES)[number];

export const MARKET_KYC_QUERY_KEY_PREFIX = 'market_kyc';

export const MarketKycMutationKeys = {
  VERIFY: () => [MARKET_KYC_QUERY_KEY_PREFIX, 'verify'],
} as const;
